import type { SupSingleVaultV3 } from "@/types";
import React from "react";

import UiLabelApy, { type SupDicApyPeriod } from "@/components/Ui/Label/Apy";
import UiLabelRewardsTag from "@/components/Ui/Label/Rewards/Tag";

interface GridCellRewardApyProps {
  vault: SupSingleVaultV3;
  isBold?: boolean;
  period?: SupDicApyPeriod;
  showTooltip?: boolean;
}

export default function GridCellRewardApy({ vault, isBold = false, period = "month", showTooltip = false }: GridCellRewardApyProps) {
  const hasRewards = (vault.rewards?.length ?? 0) > 0;

  return hasRewards ? (
    <UiLabelRewardsTag vault={vault} period={period} showTooltip={showTooltip} noAction />
  ) : (
    <UiLabelApy noAction period={period} isBold={isBold} vault={vault} />
  );
}
